module.exports = __webpack_public_path__ + "img/name.05ceb8aa.svg";